// extracted by css-extract-rspack-plugin
var _1 = "changes-blurb__MrRfn";
var _2 = "confirmation-blurb__XqLbU";
var _3 = "order-number__FjVbm";
export { _1 as "changes-blurb", _2 as "confirmation-blurb", _3 as "order-number" }
export default { "changes-blurb": _1, "confirmation-blurb": _2, "order-number": _3 }
